import { cn } from '@/lib/utils'

export function ComponentActionsContainer({ children, className }: { children: React.ReactNode; className?: string }) {
  return (
    <div className={cn('ml-auto mr-0 flex items-center gap-4 rounded-lg bg-background/50 p-2', className)}>
      {children}
    </div>
  )
}
